/* import __COLOCATED_TEMPLATE__ from './reviewable-topic-link.hbs'; */
import Component from "@ember/component";

export default Component.extend({});
